import * as _ from "lodash"
import {QueryOrder, QueryOrderDirection} from "@/cube/cubejs"
import {Dimension} from "@/cube"

export function toQueryOrderBy(
  dimensions: ReadonlyArray<Dimension>,
  order: QueryOrderDirection = "asc"
): QueryOrder {
  return _.chain(dimensions)
    .map(dimension => [dimension, order])
    .fromPairs()
    .value()
}
